import { callApi } from './api';

import { ApiResult } from '@/types/api';
import { MonthlyCalendarItem } from '@/types/monthlyCalendar';

export const createFacilityCalendars = async (
  input: MonthlyCalendarItem[]
): Promise<ApiResult<boolean>> => {
  const { status, result } = await callApi<boolean>(
    `facility-calendars`,
    'POST',
    undefined,
    input,
    undefined,
    undefined,
    true
  );
  return { status, result };
};
